
export const typePolicies = {
  Site: {
    merge: true,
  }
};
